import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=40c445e4"
import script from "./CollectionView.vue?vue&type=script&lang=js"
export * from "./CollectionView.vue?vue&type=script&lang=js"
import style0 from "./CollectionView.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports